import QRCode from 'qrcode'
export default {
  data() {
    return { qrcode: null }
  },
  methods: {
    async toBase64(content) {
      const base64 = await QRCode.toDataURL(content, { version: 4 })
      this.qrcode = String(base64)
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/longTermCare/_QRCodeGenMixin.js